"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.determinePreferredVideoCodec = void 0;
const api_1 = require("@streem/api");
const determine_supported_video_codecs_1 = require("./determine_supported_video_codecs");
function determinePreferredVideoCodec(userAgent, browser) {
    return __awaiter(this, void 0, void 0, function* () {
        const supportedCodecs = yield (0, determine_supported_video_codecs_1.determineSupportedVideoCodecs)(userAgent, browser);
        switch (supportedCodecs[0]) {
            case api_1.StreemApiDeviceSupportedVideoCodecs.H264:
                return api_1.StreemApiCreateRoomRequestPreferredCodec.H264;
            case api_1.StreemApiDeviceSupportedVideoCodecs.VP8:
                return api_1.StreemApiCreateRoomRequestPreferredCodec.VP8;
            case api_1.StreemApiDeviceSupportedVideoCodecs.VP9:
                return api_1.StreemApiCreateRoomRequestPreferredCodec.VP9;
            default:
                return undefined;
        }
    });
}
exports.determinePreferredVideoCodec = determinePreferredVideoCodec;
// @ts-ignore
window.determinePreferredVideoCodec = determinePreferredVideoCodec;
//# sourceMappingURL=determine_preferred_video_codecs.js.map